import { useQuery } from '@tanstack/react-query';
import { getMyOwnTractorImageExists } from '../../../../api/user/queries/getMyOwnTractorImageExists';
import { AxiosError } from 'axios';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export const useGetMyOwnTractorImageExists = () => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<boolean, AxiosError>(['my_own_tractor_image_exists'], getMyOwnTractorImageExists, {
    enabled: isUserLoggedIn,
  });
};
